const prefix = '[UBA]';
const isInIfr = window.top !== window;
const isDebug = window.localStorage.getItem('UBA_DEBUG_FLAG') === '1';
interface hbLogger {
  debug(message?: any, ...optionalParams: any[]): void;
  info(message?: any, ...optionalParams: any[]): void;
  warn(message?: any, ...optionalParams: any[]): void;
  error(message?: any, ...optionalParams: any[]): void;
}

const hbLogger = {} as hbLogger;
['debug', 'info', 'warn', 'error'].forEach(type => {
  hbLogger[type] = (message?: any, ...optionalParams: any[]) => {
    if(type !== 'debug' || isDebug) {
      console[type](`${prefix}[${type}]${isInIfr ? '[iframe]' : ''} ${message}`, ...optionalParams);
    }
  };
});

// @ts-ignore
window.hbLogger = hbLogger;
